
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.3 12C3.3 7.19512 7.19512 3.3 12 3.3V20.7C7.19512 20.7 3.3 16.8049 3.3 12ZM17.6081 18.6515C19.499 17.0556 20.7 14.6681 20.7 12C20.7 9.33192 19.499 6.94436 17.6081 5.34846V18.6515ZM17.6081 20.8785C20.548 19.0176 22.5 15.7368 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C13.9544 22.5 15.7841 21.966 17.3511 21.036H17.6081V20.8785ZM15.8081 19.8245C15.1776 20.1319 14.5045 20.3654 13.8 20.5136L13.8 3.48643C14.5045 3.63464 15.1776 3.86809 15.8081 4.17548L15.8081 19.8245Z","fill":"#16171F"}}),_c('path',{attrs:{"d":"M12 1.5C14.7848 1.5 17.4555 2.60625 19.4246 4.57538C21.3938 6.54451 22.5 9.21523 22.5 12C22.5 14.7848 21.3938 17.4555 19.4246 19.4246C17.4555 21.3938 14.7848 22.5 12 22.5L12 12V1.5Z","fill":"#5D5CFD"}})])
          )
        }
      }
    